import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import Scrollbar from "../components/scrollbar";
import TicketTransactionsTable from "src/components/transactions-table/TicketTransactionsTable";
import { get } from "src/utils/networkUtils";

export default function TicketTransactionsPage() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);

  useEffect(() => {
    setLoading(true);
    get(`/admin/tickets/transactions`).then(function (response) {
      setRows(response.transactions);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <Helmet>
        <title> Ticket Transactions </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Ticket Transactions
          </Typography>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TicketTransactionsTable transactions={rows} />
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
